import { useState, useRef } from "react";
import { Row, Col, Container } from "react-bootstrap";
import TrackVisibility from 'react-on-screen';
import colorSharp from "../assets/img/color-sharp.png";

const SkillCard3D = ({ name, percentage, color }) => {
  const cardRef = useRef(null);
  const [transform, setTransform] = useState('');
  const [glow, setGlow] = useState('none');

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = ((y - centerY) / centerY) * -12;
    const rotateY = ((x - centerX) / centerX) * 12;
    setTransform(`perspective(600px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.05,1.05,1.05)`);
    setGlow(`0 0 25px ${color}55, 0 8px 32px rgba(0,0,0,0.4)`);
  };

  const handleMouseLeave = () => {
    setTransform('perspective(600px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)');
    setGlow('none');
  };

  return (
    <div
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{
        background: 'linear-gradient(135deg, rgba(255,255,255,0.05), rgba(0,210,255,0.03))',
        border: `1px solid ${color}33`,
        borderRadius: '16px',
        padding: '18px 22px',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        transform: transform,
        boxShadow: glow,
        cursor: 'default',
        transformStyle: 'preserve-3d',
      }}
    >
      <TrackVisibility>
        {({ isVisible }) => (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
              <span style={{ fontSize: '15px', fontWeight: '600', color: '#e0eaf5', letterSpacing: '0.5px' }}>{name}</span>
              <span style={{ fontSize: '14px', fontWeight: '700', color: color }}>{isVisible ? percentage : 0}%</span>
            </div>
            <div style={{ width: '100%', height: '8px', background: 'rgba(255,255,255,0.08)', borderRadius: '100px', overflow: 'hidden' }}>
              <div style={{
                height: '100%',
                borderRadius: '100px',
                width: isVisible ? `${percentage}%` : '0%',
                background: `linear-gradient(90deg, ${color}88, ${color})`,
                boxShadow: isVisible ? `0 0 10px ${color}99` : 'none',
                transition: 'width 1.4s cubic-bezier(0.4, 0, 0.2, 1)',
              }} />
            </div>
          </>
        )}
      </TrackVisibility>
    </div>
  );
};

export const Skills = () => {
  const technicalSkills = [
    { name: "HTML5", percentage: 90, color: "#e34c26" },
    { name: "CSS3", percentage: 85, color: "#264de4" },
    { name: "JavaScript", percentage: 80, color: "#f7df1e" },
    { name: "React.js", percentage: 78, color: "#61dafb" },
    { name: "Node.js", percentage: 65, color: "#68a063" },
    { name: "Tailwind CSS", percentage: 80, color: "#38bdf8" },
    { name: "MongoDB", percentage: 60, color: "#47a248" },
    { name: "Bootstrap", percentage: 85, color: "#7952b3" },
    { name: "Next.js", percentage: 55, color: "#ffffff" },
    { name: "Firebase", percentage: 60, color: "#ffca28" },
    { name: "TypeScript", percentage: 50, color: "#3178c6" },
  ];

  const softSkills = [
    { name: "Communication", percentage: 90 },
    { name: "Leadership", percentage: 75 },
    { name: "Problem Solving", percentage: 85 },
    { name: "Teamwork", percentage: 90 },
    { name: "Critical Thinking", percentage: 80 },
    { name: "Time Management", percentage: 75 },
  ];

  return (
    <section className="skill" id="skills">
      <Container>
        <Row>
          <Col>
            <div className="skill-bx">
              <h2>Skills</h2>
              <p>Here are my skills and technologies I work with:</p>
              <div className="skill-cards-grid">
                {technicalSkills.map((skill, idx) => (
                  <SkillCard3D key={idx} {...skill} />
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <img className="background-image-left" src={colorSharp} alt="bg" />

      <div className="soft-skills-bx">
        <h3>Soft Skills</h3>
        <div className="soft-skills-bars">
          <TrackVisibility>
            {({ isVisible }) =>
              softSkills.map((s, i) => (
                <div className="soft-skill-item" key={i}>
                  <div className="soft-skill-label-row">
                    <span>{s.name}</span>
                    <span>{isVisible ? s.percentage : 0}%</span>
                  </div>
                  <div className="skill-bar-track">
                    <div
                      className="skill-bar-fill soft-fill"
                      style={{
                        width: isVisible ? `${s.percentage}%` : '0%',
                        transitionDelay: `${i * 0.1}s`,
                      }}
                    />
                  </div>
                </div>
              ))
            }
          </TrackVisibility>
        </div>
      </div>
    </section>
  );
};
